<template lang="pug">
.list__list-item(
  :class="itemClasses"
)
  template(v-if="![SIZE_STATE_KEYS.MD, SIZE_STATE_KEYS.SM].includes(size)")
    v-icon(
      :color="item.icon.color"
      :size="28"
    ) {{ item.icon.icon }}
  .list__list-item__content-wrapper
    slot(name="content")
      .list__list-item__title-wrapper
        .main(v-html="item.title.main")
        .additional {{ item.title.additional }}
      template(v-if="item.caption")
        .list__list-item__caption
          slot(name="caption")
            template(v-if="item.caption.icon")
              v-icon(
                :color="item.caption.color"
              ) {{ item.caption.icon }}
            div(
              :class="`${item.caption.color}--text`"
              v-html="item.caption.text"
            )
  slot(name="action")
    template(v-if="item.action")
      app-button(
        :height="40"
        @click="item.action.onClick"
      ) {{ item.action.text }}
</template>

<script>
import { SIZE_STATE_KEYS } from '@/modules/UserEvents/constants';

export default {
  name: 'EventPollListItem',
  components: {},
  props: {
    /**
     *  {
     *    icon: {
     *      icon: string;
     *      color: string;
     *    };
     *    title: {
     *      main: string;
     *      additional: string;
     *    };
     *    caption?: {
     *      text: string;
     *      icon?: string;
     *      color?: string;
     *    };
     *    action?: {
     *      text: string;
     *      onClick: Function;
     *    };
     *  };
     */
    item: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      SIZE_STATE_KEYS,
    };
  },
  computed: {
    pollRight() {
      const [right] = this.poll.poll_event_rights;
      return right;
    },
    isExpired() {
      return new Date() > new Date(this.pollRight?.ending_at);
    },
    itemClasses() {
      return {
        sm: SIZE_STATE_KEYS.SM === this.size,
        md: SIZE_STATE_KEYS.MD === this.size,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.list {
  &__list-item {
    display: flex;
    align-items: center;
    gap: 22px;
    padding: 16px 22px;
    min-height: 88px;
    border-bottom: 1px solid #{$redesignControlsBackgroundAlternative};

    &.sm {
      padding: 22px !important;
      height: auto !important;
      flex-direction: column;
    }

    &.md {
      padding: 22px !important;
      height: auto !important;
    }

    &:last-of-type {
      border: none;
    }

    &__content-wrapper {
      width: 100%;
    }

    &__title-wrapper {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      column-gap: 8px;

      & .main {
        flex-grow: 1;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 19px;

        &::v-deep .link {
          color: #{$redesignPrimaryDarken};
          font-weight: 500;
        }
      }

      & .additional {
        color: #{$redesignDisabledText};
        font-size: 14px;
        font-weight: 400;
        white-space: nowrap;
      }
    }

    &__caption {
      margin-top: 9px;
      font-size: 15px;
      font-weight: 400;
      line-height: 17px;
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }
}
</style>
